import { Box, DialogContent, DialogTitle } from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateContractInsurance } from "mobx-stores/_models/employee/contract-insurance";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getContractInsuranceFormSchema } from "./schema";

export const UpdateContractInsurance = observer(() => {
  const {
    employeeManagement: {
      openUpdateLaborContract,
      setProp,
      employeeDetail,
      getEmployeeDetail,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
    getControl,
  } = useForm<IUpdateContractInsurance>(getContractInsuranceFormSchema(), {
    cdJoiningDate: employeeDetail?.contractInsurance?.cdJoiningDate || "",
    contractExpirationDate:
      employeeDetail?.contractInsurance?.contractExpirationDate || "",
    contractNote: employeeDetail?.contractInsurance?.contractNote || "",
    contractNumber: employeeDetail?.contractInsurance?.contractNumber || "",
    contractSigningDate:
      employeeDetail?.contractInsurance?.contractSigningDate || "",
    contractTermType: employeeDetail?.contractInsurance?.contractTermType,
    contractType: employeeDetail?.contractInsurance?.contractType,
    healthInsuranceNumber:
      employeeDetail?.contractInsurance?.healthInsuranceNumber || "",
    insuranceNote: employeeDetail?.contractInsurance?.insuranceNote || "",
    insurancePaymentDate:
      employeeDetail?.contractInsurance?.insurancePaymentDate || "",
    kcbPlace: employeeDetail?.contractInsurance?.kcbPlace || "",
    note: employeeDetail?.contractInsurance?.note || "",
    personalTaxID: employeeDetail?.contractInsurance?.personalTaxID || "",
    socialInsuranceNumber:
      employeeDetail?.contractInsurance?.socialInsuranceNumber || "",
  });

  const fetchContractType = useCallback(async () => {
    const ctr = getControl("contractType");
    if (!ctr) return;
    const res = (await ctr.metaData?.searchOptionItemsAsync?.("")) || [];
    if (res) {
      ctr.setProp("optionItems", res);
    }
  }, [getControl]);

  const fetchTermDuration = useCallback(async () => {
    const ctr = getControl("contractTermType");
    if (!ctr) return;
    const res = (await ctr.metaData?.searchOptionItemsAsync?.("")) || [];
    if (res) {
      ctr.setProp("optionItems", res);
    }
  }, [getControl]);

  useEffect(() => {
    fetchContractType();
    fetchTermDuration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveHandler = useCallback(
    async (data: IUpdateContractInsurance) => {
      if (!employeeDetail || !employeeDetail?.id) return;
      await employeeBussiness.updateContractInsurance(employeeDetail?.id, data);
      await getEmployeeDetail(employeeDetail?.id);
      setProp("openUpdateLaborContract", false);
    },
    [getEmployeeDetail, employeeDetail, setProp]
  );

  return (
    <DialogForm
      open={openUpdateLaborContract}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openUpdateLaborContract", false)}
      onCancelBtnClicked={() => setProp("openUpdateLaborContract", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Cập Nhật Hợp Đồng Và Bảo Hiểm</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
